export enum EntityStatus {
  Enabled = 'ENABLED',
  Disabled = 'DISABLED',
}

export const SHARE_PAYMENT_STATUS = {
  PendingPayment: 'PENDING_PAYMENT',
  Paid: 'PAID',
  Sharing: 'SHARING',
  Shared: 'SHARED',
  Closed: 'CLOSED',
  Manual: 'MANUAL',
  Cancelled: 'CANCELLED',
} as const

export const SHARE_ORDER_STATE = {
  Draft: 'DRAFT',
  Processing: 'PROCESSING',
  Success: 'SUCCESS',
  PartialFailed: 'PARTIAL_FAILED',
  Failed: 'FAILED',
  Unknown: 'UNKNOWN',
} as const

export const SHARE_RETURN_RESULT = {
  Draft: 'DRAFT',
  Processing: 'PROCESSING',
  Success: 'SUCCESS',
  Failed: 'FAILED',
  Unknown: 'UNKNOWN',
} as const

export const SHARE_RECEIVER_STATUS = {
  Draft: 'DRAFT',
  Active: 'ACTIVE',
  Removed: 'REMOVED',
  Unknown: 'UNKNOWN',
} as const

export type SharePaymentStatus = (typeof SHARE_PAYMENT_STATUS)[keyof typeof SHARE_PAYMENT_STATUS]
export type ShareOrderState = (typeof SHARE_ORDER_STATE)[keyof typeof SHARE_ORDER_STATE]
export type ShareReturnResult = (typeof SHARE_RETURN_RESULT)[keyof typeof SHARE_RETURN_RESULT]
export type ShareReceiverStatus = (typeof SHARE_RECEIVER_STATUS)[keyof typeof SHARE_RECEIVER_STATUS]
